export const socials = [
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/strengthscaling/',
        path: 'M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM17 5.8a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2ZM12 4.1c2.6 0 2.9 0 3.9.06 2.6.12 3.85 1.38 3.97 3.98.05 1 .05 1.3.05 3.86s0 2.86-.05 3.86c-.12 2.6-1.37 3.86-3.97 3.98-1 .05-1.3.05-3.9.05s-2.9 0-3.9-.05c-2.6-.12-3.85-1.38-3.97-3.98C4.07 14.86 4.07 14.56 4.07 12s0-2.86.06-3.86C4.25 5.54 5.5 4.28 8.1 4.16c1-.05 1.3-.06 3.9-.06Zm0-1.7c-2.64 0-2.97.01-4 .06C4.4 2.62 2.62 4.4 2.46 8c-.05 1.03-.06 1.36-.06 4s.01 2.97.06 4c.16 3.6 1.94 5.38 5.54 5.54 1.03.05 1.36.06 4 .06s2.97-.01 4-.06c3.6-.16 5.38-1.94 5.54-5.54.05-1.03.06-1.36.06-4s-.01-2.97-.06-4C21.38 4.4 19.6 2.62 16 2.46c-1.03-.05-1.36-.06-4-.06Z'
    },
    {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/company/strengthscaling/',
        path: 'M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0Z'
    }
]

export const legalLinks = [
    { label: 'Privacy Policy.', href: '/privacy' },
    { label: 'Terms of Service.', href: '/terms' },
    { label: 'Account & Data Deletion.', href: '/support/delete-account' }
]
